import { HTMLAttributes } from 'react';
import styled from 'styled-components';

import { Rarity } from '__generated__/globalTypes';
import Shine from 'atoms/ui/Shine';
import { CARD_BORDER_RADIUS } from 'lib/cards';

import commonBack from './assets/common.png';
import limitedBack from './assets/limited.png';
import rareBack from './assets/rare.png';
import superRareBack from './assets/super_rare.png';
import uniqueBack from './assets/unique.png';

type WithPath = {
  path: string;
  rarity?: never;
  shine?: boolean;
};

type Default = {
  path?: never;
  rarity: Rarity;
  shine?: boolean;
};

type Props = (Default | WithPath) & HTMLAttributes<HTMLElement>;

const Image = styled.img`
  aspect-ratio: var(--card-aspect-ratio);
  width: 235px;
  max-width: 100%;
`;

export const CardBack = ({ rarity, shine, path, ...divAttributes }: Props) => {
  if (rarity === Rarity.custom_series) {
    return null;
  }

  const selectedPath =
    path ||
    (rarity &&
      {
        [Rarity.common]: commonBack,
        [Rarity.limited]: limitedBack,
        [Rarity.rare]: rareBack,
        [Rarity.super_rare]: superRareBack,
        [Rarity.unique]: uniqueBack,
      }[rarity]);

  return (
    <Shine
      disabled={!shine}
      borderRadius={CARD_BORDER_RADIUS}
      {...divAttributes}
    >
      <Image src={selectedPath} alt={rarity} />
    </Shine>
  );
};
